<template>
  <div  class="goods-col" @click="navToDetail(item.goodsId)">
    <div   class="goods-horizontal">
      <div  class="img_item">
        <img v-lazy="item.mainPic+'_310x310.jpg'"
             ></div>
      <div  class="right_content">
        <div  class="item_right_title_wrap">
          <div  class="tag_wrap"><span
          ><span
                  class="item_right_tag"
                  style="background-image: linear-gradient(rgb(255, 126, 110) 0%, rgb(255, 0, 50) 100%);">天猫</span></span><span

                  class="item_right_title">{{item.title}}</span></div>
          <div  class="tags" style="display: flex">
            <div  class="quan_wrap" v-show="item.couponPrice > 0"><span
                    class="tags_quan"><span
                    class="quan">券</span><span
                    class="quan_yuan">{{item.couponPrice}}元</span></span>
            </div>
            <div  class="lijin_wrap" v-show="subsidy > 0"><span
                    class="tags_lijin"><span
                    class="lijin">礼金</span><span
                    class="lijin_yuan">{{subsidy}}元</span></span>
            </div>
          </div>
          <div  class="price_wrap">
            <div  class="huodong"> ￥<span
                    class="pri">{{item|tbCouponPrice(appConfig, userInfo)}}</span><span
            >活动价</span></div>
            <span  class="origin">￥{{item.originPrice}}</span>

          </div>
          <div v-show="userInfo.userType == 0" > 佣金比例:{{item.commissionRate}}% </div>
          <div  class="rexiao">
            <div  class="rexiao_left"><img

                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAAAXNSR0IArs4c6QAAAuhJREFUOE+dVUtoU0EUPXeS1kUtlWpNk64EF4KC1I0b0WLVjYg2L4EW1LoSQRd5NbbqQp+C30rTLhREhFihqPmAH1BRoaAuhEJXLlwIrppPrdBVf8lcmeFNfUlbKw48XjJz77nn3jn3PkLVYscR5DiyaEc3l7n8mkHJYCJzHQTAcUidVfuo/+q4YnE06qNUqjxhWzYxDwAogzDMDQtngs7LGdeJq/0qgBggAngyFg6WIcYYMgRgAUANET2faajv3OQkZ42dF6wSyGWTt63HzHxUswGE+/YT0YPmROakAjIgKnBFaqY2hVgkLiH7AahaKBCzlAMJCCswmM6aEhh2Gtls5mNWF4NH1Jbr7WWs2PnAGA8OZXfkbesQEYUCA+n7msQiSNzaiRK/YWDdMmwMK81SALskie2AvLOm1hdsvJWa1hF/9UUb5ufkJwZv+wuIMtWsiCihM2G2iehCcyJzUwMVbOuSZL5iDJfTScUe0QKB55lRB2DMX1vaS5O9naHS3PwHELaswmaJ5EwdhY8PUDEWjpSB1D+zqbxFVTMfgD7K2x03mOn8fwApSCORJOVi4UcAjq+QlpKBerx68qZogNJUiHUkJah7lfpoMS5zCRqICQ8pZ1vnwHwbQAmA3zXWjgR8ZeI8mNpXSF37CIFTlItH2lCS71wQE1nrhZlGgjPrTxTWTj1jyUeqWBvbaSbap+nmYuFXAA6aTv8jPDxpTmS7ftrRlhKXvzDQ4tZM+empAGA4OJjt1kDFHqtVMt4yc5MLoqL5BdHlQCJzVdnk7chFZnnNLYHy8wFiQtT4dgf6n35f7LXC2Y79skwZAPVuVGYSbaFE+qMG6om0s5TvPbWaEsDhwGD2s+5Xb/fnbGsrMd9lYI9g3AsMZU+z0+YnZ7SkzsA8CmADIF74mXqbhlLfTNMvXqmZR/n4sTrBs61N9XVj5JmGCrA43ahGx4+NA5lxM9yWDDbNzB38+rerG2Po1ZA+q/oQ/AYZX15zcssz7AAAAABJRU5ErkJggg=="
                    alt=""> 热销{{(item.monthSales>0?item.monthSales:item.dailySales)|formatSale}}件
            </div>
            <div  class="qiang"
                  style="background: rgb(183, 41, 21);"> 马上抢
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Coupon from '../../libs/coupon'
import Util from '../../libs/util'
import {mapState} from 'vuex'
export default {
  props: {
      item: {
         type: Object,
         default() {
           return {}
         }
      },
      couponPrice:{
          type: Number,
          default: 0
      },

      subsidy: {
          type: Number,
          default: 0
      },
      rebate: {
          type: Number,
          default: 0
      },
      sales: {
          type: Number,
          default: 0
      }
  },
  computed: {
      ...mapState([
          'appConfig',
          'userInfo',
      ])

  },

  filters:{
      tbCouponPrice(item, appConfig, userInfo) {
          return Coupon.tbCouponPrice(parseFloat(item.actualPrice)+parseInt(item.couponPrice), item.couponPrice, item.commissionRate, appConfig.subsidyCommonLimit, userInfo, appConfig, '1');
      },

      formatSale(sales) {
          return Util.formatSale(parseInt(sales));
      },


  },
  methods:{
      navToDetail(id){
          this.$router.push({
              name:'itemdetail',params: {id:id, subsidyType:2,couponType:'tb',bybtInfo:{}}
          })
      },
  }
};
</script>
<style >
  .goods-horizontal {
    width: 7.1rem;
    height: 2.8rem;
    display: flex;
    background: #fff;
    border-radius: 0.1rem;
    margin-top: 0.2rem;
  }
  .goods-horizontal .img_item img {
    width: 2.8rem;
    height: 2.8rem;
    border-radius: 0.1rem 0 0 0.1rem;
  }
  .goods-horizontal .right_content {
    width: 4rem;
    margin-left: 0.1rem;
    padding: 0.1rem;
    flex: 1;
  }
  .goods-horizontal .right_content .item_right_title_wrap {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .goods-horizontal .right_content .item_right_title_wrap .tag_wrap {
    display: flex;
    align-items: center;
  }
  .goods-horizontal .right_content .tags .tags_quan{
    background-image: linear-gradient(
            90deg
            ,#ff8873 2%,#ff4f4f 98%);
    border-radius: 0.04rem;
    padding: 0.03rem;
    font-size: .18rem;
    color: #fff;
    vertical-align: middle;
    margin-right: 0.1rem;
  }
  .goods-horizontal .right_content .tags .tags_quan .quan{
    font-size: .18rem;
    background: #fff;
    color: #fe3a33;
    line-height: 1;
    text-align: center;
    margin-right: 0.06rem;
  }
  .goods-horizontal .right_content .tags .tags_quan .quan_yuan{
    font-size: .19rem;
  }

  .goods-horizontal .right_content .tags .tags_lijin{
    background-image: linear-gradient(
            90deg,#ff8873,#ff976a);
    border-radius: 0.04rem;
    padding: 0.03rem;
    font-size: .18rem;
    color: #fff;
    vertical-align: middle;
    margin-right: 0.1rem;
  }
  .goods-horizontal .right_content .tags .tags_lijin .lijin{
    font-size: .18rem;
    background: #fff;
    color: #ff976a;
    line-height: 1;
    text-align: center;
    margin-right: 0.06rem;
  }
  .goods-horizontal .right_content .tags .tags_lijin .lijin_yuan{
    font-size: .19rem;
  }


  .goods-horizontal .right_content .item_right_title_wrap .tag_wrap .item_right_tag {
    width: 0.46rem;
    height: 0.26rem;
    margin-right: 0.1rem;
    position: relative;
    white-space: nowrap;
    align-items: center;
    padding: 0 0.03rem;
    color: #fff;
    line-height: .32rem;
    border-radius: 0.04rem;
  }
  .goods-horizontal .right_content .item_right_title_wrap .tag_wrap .item_right_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: .28rem;
    color: #333;
  }


  .goods-horizontal .right_content .tags {
    line-height: 1;
    margin-top: 0.32rem;
  }
  .goods-horizontal .right_content .price_wrap {
    margin-top: 0.36rem;
    display: flex;
    align-items: flex-end;
  }
  .goods-horizontal .right_content .price_wrap .huodong {
    color: #fe3738;
    font-family: PingFangSC-Medium;
    font-size: .22rem;
  }
  .goods-horizontal .right_content .price_wrap .huodong .pri {
    font-family: PingFangSC-Medium;
    font-size: .4rem;
    margin-right: 0.1rem;
  }
  .goods-horizontal .right_content .price_wrap .origin {
    margin-left: 0.05rem;
    padding-bottom: 0.02rem;
    font-family: PingFangSC-Regular;
    font-size: .2rem;
    color: #999;
    text-decoration: line-through;
  }
  .goods-horizontal .right_content .rexiao {
    display: flex;
    position: relative;
    margin-top: 0.2rem;
  }
  .goods-horizontal .right_content .rexiao .rexiao_left {
    width: 3.36rem;
    height: 0.44rem;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0 0 0.2rem;
    font-size: .22rem;
    color: #c4310b;
    font-family: PingFangSC-Regular;
    background-image: linear-gradient(
            90deg
            ,#fff0dc,#ffdcbd);
    border-radius: 0.04rem;
  }
  .goods-horizontal .right_content .rexiao .rexiao_left img {
    width: 0.18rem;
    height: 0.22rem;
    margin-right: 0.06rem;
    margin-top: 0.02rem;
  }
  .goods-horizontal .right_content .rexiao .qiang {
    position: absolute;
    top: -0.07rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .24rem;
    color: #fff;
    right: 0.3rem;
    width: 1.5rem;
    height: 0.52rem;
    background-image: linear-gradient(
            270deg
            ,#ff4242,#ff7b57);
    box-shadow: 0 0.04rem 0.06rem 0 rgb(255 37 77 / 21%);
    border-radius: 0.08rem;
  }

</style>

